import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CheckboxField from '../../CheckboxField';
import FormError from '../../FormError';
import { formatSaveStatus } from 'helpers/formatters';
import SubNav from 'components/SubNav/simo';

let AutoRenew = ({ sub, handleSubmit, error, saveStatus }) => (
  <div>
    <h1>Modify Auto Renew</h1>
    {sub && <SubNav sub={sub} />}
    <form className="mar-t" onSubmit={handleSubmit}>
      <Field
        component={CheckboxField}
        name="renewal_enabled"
        label="Auto Renew"
      />
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        Change Auto Renew
      </button>
      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
    </form>
  </div>
);

AutoRenew = reduxForm({
  form: 'autoRenew',
  enableReinitialize: true,
})(AutoRenew);

export default AutoRenew;
